import { render } from "./FormProductsSingle.vue?vue&type=template&id=2851f275&scoped=true"
import script from "./FormProductsSingle.vue?vue&type=script&lang=js"
export * from "./FormProductsSingle.vue?vue&type=script&lang=js"

import "./FormProductsSingle.vue?vue&type=style&index=0&id=2851f275&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2851f275"]])

export default __exports__